import type { CSSProperties } from 'react';
import type { ImageNode } from 'data-layer';
import { MAGAZINE_VIDEO_ASPECT_RATIO } from '../../../constants';

export const MAGAZINE_MEDIA_ASPECT_RATIO_VAR = '--magazine-media-aspect-ratio';

/**
 * Reserves the image box before it loads (works without JS). Exposed as a custom property so the CSS can apply it on
 * mobile only; on desktop the third-party magazine CSS stretches the media to the row height instead.
 *
 * The orientation is read from the tag size, not from `image.isPortrait`: the latter describes the source asset, while
 * a cropped image is delivered (and its tag sized) at the crop ratio.
 *
 * @param image - Image node carrying the rendered tag size
 * @returns Inline style, or undefined for portrait tag sizes / missing dimensions
 */
export function getMediaAspectRatioStyle(image?: ImageNode): CSSProperties | undefined {
  const width = image?.imageTagWidth;
  const height = image?.imageTagHeight;

  if (!width || !height || height > width) {
    return undefined;
  }

  return { [MAGAZINE_MEDIA_ASPECT_RATIO_VAR]: `${width} / ${height}` } as CSSProperties;
}

/**
 * Reserves the video box before the poster, thumbnail or iframe arrives. Videos have no dimensions in the data, so
 * every video gets the same fixed ratio.
 *
 * @returns Inline style carrying the video aspect ratio
 */
export function getVideoAspectRatioStyle(): CSSProperties {
  return { [MAGAZINE_MEDIA_ASPECT_RATIO_VAR]: MAGAZINE_VIDEO_ASPECT_RATIO } as CSSProperties;
}
